import { render, staticRenderFns } from "./local_4.vue?vue&type=template&id=c3b00356&scoped=true&"
import script from "./local_4.vue?vue&type=script&lang=js&"
export * from "./local_4.vue?vue&type=script&lang=js&"
import style0 from "./local_4.vue?vue&type=style&index=0&id=c3b00356&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3b00356",
  null
  
)

export default component.exports